"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M4 9h16v2H4zm0 4h10v2H4z"
}), 'ShortTextTwoTone');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/ShortTextTwoTone.js
// module id = 5225
// module chunks = 0